var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaskTodoPlaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 303,
    height: 154,
    viewBox: "0 0 303 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_52_10964)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 76,
    width: 189,
    height: 58,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8906 103.875C72.3906 103.812 72.1406 103.531 72.1406 103.031C72.4844 101.156 73.1875 99.4844 74.25 98.0156C74.5938 97.6406 74.9531 97.6094 75.3281 97.9219C75.6094 98.2344 75.6406 98.5781 75.4219 98.9531C74.5156 100.203 73.9219 101.625 73.6406 103.219C73.5469 103.625 73.2969 103.844 72.8906 103.875ZM77.9531 96.4219C77.5781 96.6406 77.2344 96.6094 76.9219 96.3281C76.6094 95.9531 76.6406 95.5938 77.0156 95.25C78.4844 94.1875 80.1719 93.4844 82.0781 93.1406C82.5469 93.1406 82.8125 93.3906 82.875 93.8906C82.8438 94.2969 82.625 94.5469 82.2188 94.6406C80.625 94.9219 79.2031 95.5156 77.9531 96.4219ZM85.125 116.109C85.1562 115.703 85.375 115.453 85.7812 115.359C87.375 115.078 88.7969 114.484 90.0469 113.578C90.3906 113.359 90.7344 113.391 91.0781 113.672C91.3906 114.047 91.3594 114.406 90.9844 114.75C89.5156 115.812 87.8438 116.516 85.9688 116.859C85.4688 116.859 85.1875 116.609 85.125 116.109ZM92.5781 111.047C93.4844 109.797 94.0781 108.375 94.3594 106.781C94.4531 106.375 94.7031 106.156 95.1094 106.125C95.6094 106.188 95.8594 106.469 95.8594 106.969C95.5156 108.844 94.8125 110.516 93.75 111.984C93.4062 112.359 93.0469 112.391 92.6719 112.078C92.3906 111.766 92.3594 111.422 92.5781 111.047ZM76.9219 113.672C77.2344 113.391 77.5781 113.359 77.9531 113.578C79.2031 114.484 80.625 115.078 82.2188 115.359C82.625 115.453 82.8438 115.703 82.875 116.109C82.8125 116.609 82.5312 116.859 82.0312 116.859C80.1562 116.516 78.4844 115.812 77.0156 114.75C76.6406 114.406 76.6094 114.047 76.9219 113.672ZM74.25 111.984C73.1875 110.516 72.4844 108.844 72.1406 106.969C72.1406 106.469 72.3906 106.188 72.8906 106.125C73.2969 106.156 73.5469 106.375 73.6406 106.781C73.9219 108.375 74.5156 109.797 75.4219 111.047C75.6406 111.422 75.6094 111.766 75.3281 112.078C74.9531 112.391 74.5938 112.359 74.25 111.984ZM91.0781 96.3281C90.7656 96.6094 90.4219 96.6406 90.0469 96.4219C88.7969 95.5156 87.375 94.9219 85.7812 94.6406C85.375 94.5469 85.1562 94.2969 85.125 93.8906C85.1875 93.3906 85.4688 93.1406 85.9688 93.1406C87.8438 93.4844 89.5156 94.1875 90.9844 95.25C91.3594 95.5938 91.3906 95.9531 91.0781 96.3281ZM92.5781 98.9531C92.3594 98.5781 92.3906 98.2344 92.6719 97.9219C93.0469 97.6094 93.4062 97.6406 93.75 98.0156C94.8125 99.4844 95.5156 101.156 95.8594 103.031C95.8594 103.531 95.6094 103.812 95.1094 103.875C94.7031 103.844 94.4531 103.625 94.3594 103.219C94.0781 101.625 93.4844 100.203 92.5781 98.9531Z",
    fill: "#A7A7BE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 93,
    height: 19,
    transform: "translate(112 87)",
    fill: "#DEDEE6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 12.801,
    transform: "translate(112 110)",
    fill: "#DEDEE6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 76,
    width: 8,
    height: 58,
    fill: "#A98EDA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 76.5,
    width: 188,
    height: 57,
    rx: 7.5,
    stroke: "#CECEDA"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_52_10964)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_52_10964)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66.0606,
    y: 32,
    width: 188.939,
    height: 57.936,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9512 59.843C98.4512 59.7805 98.2012 59.4993 98.2012 58.9993C98.545 57.1243 99.2481 55.4524 100.311 53.9836C100.654 53.6086 101.014 53.5774 101.389 53.8899C101.67 54.2024 101.701 54.5461 101.482 54.9211C100.576 56.1711 99.9825 57.593 99.7012 59.1868C99.6075 59.593 99.3575 59.8118 98.9512 59.843ZM104.014 52.3899C103.639 52.6086 103.295 52.5774 102.982 52.2961C102.67 51.9211 102.701 51.5618 103.076 51.218C104.545 50.1555 106.232 49.4524 108.139 49.1086C108.607 49.1086 108.873 49.3586 108.936 49.8586C108.904 50.2649 108.686 50.5149 108.279 50.6086C106.686 50.8899 105.264 51.4836 104.014 52.3899ZM111.186 72.0774C111.217 71.6711 111.436 71.4211 111.842 71.3274C113.436 71.0461 114.857 70.4524 116.107 69.5461C116.451 69.3274 116.795 69.3586 117.139 69.6399C117.451 70.0149 117.42 70.3743 117.045 70.718C115.576 71.7805 113.904 72.4836 112.029 72.8274C111.529 72.8274 111.248 72.5774 111.186 72.0774ZM118.639 67.0149C119.545 65.7649 120.139 64.343 120.42 62.7493C120.514 62.343 120.764 62.1243 121.17 62.093C121.67 62.1555 121.92 62.4368 121.92 62.9368C121.576 64.8118 120.873 66.4836 119.811 67.9524C119.467 68.3274 119.107 68.3586 118.732 68.0461C118.451 67.7336 118.42 67.3899 118.639 67.0149ZM102.982 69.6399C103.295 69.3586 103.639 69.3274 104.014 69.5461C105.264 70.4524 106.686 71.0461 108.279 71.3274C108.686 71.4211 108.904 71.6711 108.936 72.0774C108.873 72.5774 108.592 72.8274 108.092 72.8274C106.217 72.4836 104.545 71.7805 103.076 70.718C102.701 70.3743 102.67 70.0149 102.982 69.6399ZM100.311 67.9524C99.2481 66.4836 98.545 64.8118 98.2012 62.9368C98.2012 62.4368 98.4512 62.1555 98.9512 62.093C99.3575 62.1243 99.6075 62.343 99.7012 62.7493C99.9825 64.343 100.576 65.7649 101.482 67.0149C101.701 67.3899 101.67 67.7336 101.389 68.0461C101.014 68.3586 100.654 68.3274 100.311 67.9524ZM117.139 52.2961C116.826 52.5774 116.482 52.6086 116.107 52.3899C114.857 51.4836 113.436 50.8899 111.842 50.6086C111.436 50.5149 111.217 50.2649 111.186 49.8586C111.248 49.3586 111.529 49.1086 112.029 49.1086C113.904 49.4524 115.576 50.1555 117.045 51.218C117.42 51.5618 117.451 51.9211 117.139 52.2961ZM118.639 54.9211C118.42 54.5461 118.451 54.2024 118.732 53.8899C119.107 53.5774 119.467 53.6086 119.811 53.9836C120.873 55.4524 121.576 57.1243 121.92 58.9993C121.92 59.4993 121.67 59.7805 121.17 59.843C120.764 59.8118 120.514 59.593 120.42 59.1868C120.139 57.593 119.545 56.1711 118.639 54.9211Z",
    fill: "#A7A7BE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 92.9394,
    height: 19.201,
    transform: "translate(138.061 42.967)",
    fill: "#DEDEE6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 12.801,
    transform: "translate(138.061 66.168)",
    fill: "#DEDEE6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.0606,
    y: 32,
    width: 8,
    height: 58,
    fill: "#A98EDA"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 66.5606,
    y: 32.5,
    width: 187.939,
    height: 56.936,
    rx: 7.5,
    stroke: "#CECEDA"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_52_10964",
    x: 36,
    y: 74,
    width: 197,
    height: 66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0980392 0 0 0 0 0.0901961 0 0 0 0 0.168627 0 0 0 0.075 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_52_10964"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_52_10964",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_52_10964",
    x: 18.0606,
    y: 0,
    width: 284.939,
    height: 153.936,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0980392 0 0 0 0 0.0901961 0 0 0 0 0.168627 0 0 0 0.175 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_52_10964"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_52_10964",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_52_10964"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66.0606,
    y: 32,
    width: 188.939,
    height: 57.936,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskTodoPlaceholder);
export default __webpack_public_path__ + "static/media/task-todo-placeholder.8731da6d61cc69f14aee47379501baf9.svg";
export { ForwardRef as ReactComponent };